import React, {useState} from "react";
import Calendar from "react-calendar";
import 'react-calendar/dist/Calendar.css';
import Popup from "../../ui/Popup";
import Input from "../Input";
import {connect} from "react-redux";
import {t} from "../../../components/Translate";
import "./styles.css"
import CalendarDaysIcon from "../../../assets/icons/CalendarDaysIcon";
import SilverButton from "../../buttons/SilverButton";
import RefreshIcon from "../../../assets/icons/RefreshIcon";
import colors from "../../../utils/Colors";
import {startOfUserDay, endOfUserDay} from "../../../utils/DateUtils";

const DatePicker = ({
                        selectRange = false,
                        value,
                        onChange,
                        panelAlign = {horizontal: "left", vertical: ""},
                        user,
                        defaultValue = null,
                        onReset,
                        disabled = false,
                        inputContainerStyle = {},
                        popupStyle = {},
                        placeholder = null,
                        endOfDay = false,
                    }) => {

    const [isOpen, setIsOpen] = useState(false);

    const formatDate = (date) => {
        if (!date) return "";
        if (Array.isArray(date)) {
            const [start, end] = date;
            return start && end
                ? `${start.toLocaleDateString(user.language, { day: "2-digit", month: "2-digit", year: "numeric" }).replace(/\//g, ".")} - ${end.toLocaleDateString(user.language, { day: "2-digit", month: "2-digit", year: "numeric" }).replace(/\//g, ".")}`
                : "";
        }
        return date
            .toLocaleDateString(user.language, { day: "2-digit", month: "2-digit", year: "numeric" })
            .replace(/\//g, ".");
    };

    const handleChange = (date) => {
        let result = date;

        if (!selectRange && date instanceof Date) {
            result = endOfDay ? endOfUserDay(date) : startOfUserDay(date);
        }

        if (selectRange && Array.isArray(date)) {
            const [start, end] = date;

            const newStart = start ? startOfUserDay(start) : null;
            const newEnd = end ? (endOfDay ? endOfUserDay(end) : startOfUserDay(end)) : null;

            result = [newStart, newEnd];
        }

        if (!selectRange) setIsOpen(false);
        onChange(result);
    };


    const showResetButton = () => {
        if(!defaultValue)return value !== null;

        if(Array.isArray(defaultValue)) {
            return value && (defaultValue[0].getTime() !== value[0].getTime() || defaultValue[1].getTime() !== value[1].getTime());
        }

        return value && defaultValue.getTime() !== value.getTime();

    }

    return (
        <Popup
            trigger={
                <div className="date-picker-input-container" style={{...inputContainerStyle}}>
                    <Input
                        value={formatDate(value)}
                        style={{cursor: disabled ? "not-allowed" : "pointer", height: "100%"}}
                        placeholder={t({text: placeholder ? placeholder : 'date', user})}
                        leadingIcon={
                            <CalendarDaysIcon
                                width={18}
                                height={18}
                                className="date-picker-input-icon"
                            />
                        }
                        readOnly
                        disabled={disabled}
                    />

                    {
                        onReset && showResetButton() &&
                        <SilverButton
                            variant="ghost"
                            className="date-picker-reset-button"
                            width={'24px'}
                            height={'24px'}
                            onClick={e => {e.stopPropagation(); onReset()}}
                            disabled={disabled}
                        >
                            <RefreshIcon width={16} height={16} style={{color: colors.silverDark}} stroke="currentColor" />
                        </SilverButton>
                    }
                </div>
            }
            direction="bottom"
            panelAlign={panelAlign}
            isOpen={isOpen}
            onOpenChange={setIsOpen}
            disabled={disabled}
            style={{...popupStyle}}
        >
            <div className="date-picker-popup-container">
                <Calendar
                    locale={user.language}
                    selectRange={selectRange}
                    onChange={handleChange}
                    value={value}
                />
            </div>
        </Popup>
    );
};

const mapSateToProps = state => ({
    user: state.user,
});

export default connect(mapSateToProps)(DatePicker)



// WEBPACK FOOTER //
// ./src/components-new/form/DatePicker/index.jsx